import { useMutation } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { fetchBulkStocks } from "services/stockService";
import { Icon } from "@iconify/react";

const BulkScan = ({ isOpen, onClose, data, onAddStock, clientCode,setScannedText,scannedText }) => {
    const {
      data: bulkStocks,
      isError: bulkStocksIsError,
      isPending:bulkStocksIsLoading,
      isSuccess: bulkStocksIsSuccess,
      mutate: getBulkStocks,
    } = useMutation({ mutationFn: fetchBulkStocks });
  
   
    const [scannedLabels, setScannedLabels] = useState([]);


    useEffect(()=>{
      if(bulkStocksIsSuccess){
        
        if(!bulkStocks?.length){
            toast.error("No items matched with scanned labels",{
                position:'top-center',
                durationL:"2000"
            })
        }else{
            onAddStock(bulkStocks)
        }
      }
    },[bulkStocksIsSuccess])
    useEffect(()=>{
      if(bulkStocksIsSuccess){
        console.log(bulkStocks)
      }
    },[bulkStocksIsSuccess,bulkStocks])
    useEffect(()=>{
        if(scannedText){

       
        const labelLength = 24;
        const newLabelsSet = new Set(scannedLabels);
    
        for (let i = 0; i < scannedText.length; i += labelLength) {
          const label = scannedText.substring(i, i + labelLength);
          if (label.length === labelLength) {
            newLabelsSet.add(label);
          }
        }
    
        setScannedLabels(Array.from(newLabelsSet));
    }else{
        setScannedLabels("")
    }
    },[scannedText])
    const handleScan = (event) => {
      if (bulkStocksIsLoading) return; // Prevent input while loading
  
      const inputValue = event.target.value.trim();
      setScannedText(inputValue);
  
     
    };
   
    function resetTable(){
      setScannedText("");
      setScannedLabels([]);
    }
    const handleReset = () => {
      if (bulkStocksIsLoading) return;
      setScannedText("");
      setScannedLabels([]);
    };
  
    const handleAddStock = () => {
        console.log("working")
      if (bulkStocksIsLoading) return;
      getBulkStocks({
        payload: {
          clientCode: clientCode || "client123", 
          TIDNumbers: scannedLabels,
        },
      });
    };
  
    if (!isOpen) return null;
  
    return (
      <div style={styles.overlay}>
        {/* Disable interactions with a loading overlay */}
        {bulkStocksIsLoading && <div style={styles.loadingOverlay} />}
  
        <div style={styles.modal}>
          {bulkStocksIsLoading && (
            <div style={styles.spinnerContainer}>
              <div className="spinner"></div>
            </div>
          )}
  
          <div style={styles.inputContainer}>
            <input
              type="text"
              placeholder="Place cursor here..."
              value={scannedText}
              onChange={handleScan}
              style={styles.input}
              
              disabled={bulkStocksIsLoading} // Disable input when loading
            />
          </div>
  
          {/* <div style={{ overflowX: "auto" }}>
            <table style={styles.table}>
              <thead style={styles.thead}>
                <tr>
                  <th style={styles.th}>Sr No</th>
                  <th style={styles.th}>EPC Value</th>
                </tr>
              </thead>
              <tbody>
                {scannedLabels.length > 0 ? (
                  scannedLabels.map((label, index) => (
                    <tr key={index} style={styles.tr}>
                      <td style={styles.td}>{index + 1}</td>
                      <td style={styles.td}>{label}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" style={{ ...styles.td, textAlign: "center", color: "gray" }}>
                      No Data Available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div> */}

<div style={{ overflowX: "auto" }}>
  <div style={{ maxHeight: "300px", overflowY: "auto", border: "1px solid #ddd" , scrollbarWidth: "thin", scrollbarColor: '#657484'}}>
    <table style={{ ...styles.table, borderCollapse: "collapse", width: "100%" }}>
      <thead style={{ ...styles.thead, position: "sticky", top: 0, background: "#007bff", zIndex: 1 }}>
        <tr>
          <th style={styles.th}>Sr No</th>
          <th style={styles.th}>EPC Value</th>
        </tr>
      </thead>
      <tbody>
        {scannedLabels.length > 0 ? (
          scannedLabels.map((label, index) => (
            <tr key={index} style={styles.tr}>
              <td style={styles.td}>{index + 1}</td>
              <td style={styles.td}>{label}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="2" style={{ ...styles.td, textAlign: "center", color: "gray" }}>
              No Data Available
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
</div>

  
          <div style={styles.buttonRow}>
            
              <button style={styles.totalButton} type="button" disabled={bulkStocksIsLoading}>
                Total Scanned Labels: {scannedLabels.length}
              </button>
            
            <div style={styles.rightButtons}>
            <button onClick={()=>{
                handleReset()
                onClose()
                }} style={styles.cancelButton} type="button" disabled={bulkStocksIsLoading}>
                  <Icon icon="akar-icons:cross" width="24" height="24" />
                  
                Cancel
              </button>
              <button onClick={handleReset} style={styles.resetButton} type="button" disabled={bulkStocksIsLoading}>
              <Icon style={{color: '#fff'}} icon="ix:reset" width="24" height="24" />
                Reset
              </button>
             
              <button onClick={handleAddStock} style={styles.addStockButton} type="button" disabled={bulkStocksIsLoading}>
              <Icon icon="tabler:plus" width="24" height="24" />
                Add Stock
              </button>
            </div>
          </div>
        </div>
  
        <style>
          {`
            .spinner {
              width: 50px;
              height: 50px;
              border: 5px solid rgba(255, 255, 255, 0.3);
              border-top: 5px solid #007bff;
              border-radius: 50%;
              animation: spin 1s linear infinite;
            }
  
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  };
  
  const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0, 0, 0, 0.3)", // Semi-transparent background
      backdropFilter: "blur(5px)", // Blur effect
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    loadingOverlay: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(255, 255, 255, 0.7)",
      zIndex: 5,
    },
    modal: {
      backgroundColor: "white",
      padding: "20px",
      borderRadius: "8px",
      width: "50%",
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
      position: "relative",
    },
    spinnerContainer: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      zIndex: 10,
      background: "rgba(255, 255, 255, 0.8)",
      borderRadius: "10px",
      padding: "20px",
    },
    inputContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
      marginBottom: "15px",
    
    },
    input: {
      width: "100%",
      padding: "10px",
      border: "2px solid #007bff",
      borderRadius: "5px",
      fontSize: "16px",
      outline: "none",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      border: "1px solid #ddd",
    },
    thead: {
      backgroundColor: "#007bff",
      color: "white",
    },
    th: {
      border: "1px solid #ddd",
      padding: "8px",
      textAlign: "left",
      fontWeight: "bold",
      color: "#fff",
    },
    tr: {
      textAlign: "center",
    },
    td: {
      border: "1px solid #ddd",
      padding: "8px",
    },
    buttonRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: "15px",
    },
    leftButtons: {
      flex: 1,
    },
    rightButtons: {
      display: "flex",
      gap: "10px",
   
     
    },
    totalButton: {
      backgroundColor: "#0077d4",
      color: "white",
      padding: "10px",
      border: "none",
      borderRadius: "5px",
      fontWeight: "bold",
    },
    resetButton: {
      backgroundColor: "#0077d4",
      color: "#fff",
      padding: "10px",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",

    },
    cancelButton: {
      backgroundColor: "#0077d4",
      color: "white",
      padding: "10px",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
    },
    addStockButton: {
      backgroundColor: "#0077d4",
      color: "white",
      padding: "10px",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
    width: '44%'
    },
  };
  
  export default BulkScan;
  